import { render, staticRenderFns } from "./ExchangeToken.vue?vue&type=template&id=8316e2ee"
import script from "./ExchangeToken.vue?vue&type=script&lang=js"
export * from "./ExchangeToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports